<div class="ui-helper-clearfix">
  <div class="grid">
    <div class="col-2">
      <span class="bold">{{section.type}}</span>
    </div>

    <div [ngSwitch]="section.type" class="col-8">
      <div *ngSwitchCase="'MENU'">
        <div>{{section.title}}</div>
        <div>
          <img *ngFor="let card of section.cards" [src]="card.imageUrl" style="height: 40px">
        </div>
      </div>

      <div *ngSwitchCase="'BANNER'">
        <img *ngFor="let card of section.cards" [src]="card.imageUrl" style="height: 40px">
      </div>

      <div *ngSwitchCase="'COVER'">
      <div *ngFor="let card of section.cards">
        <div>{{card.title}}</div>
        <img [src]="card.imageUrl" style="height: 60px">
      </div>
    </div>

      <div *ngSwitchCase="'CAROUSEL'">
        <div>{{section.title}}</div>
          <img *ngFor="let card of section.cards" [src]="card.imageUrl" style="height: 60px; padding-right: 5px">
      </div>

      <div *ngSwitchDefault>
        <div>{{section.title}}</div>
      </div>
    </div>

    <div class="col-2">{{section.cards.length}} items</div>
  </div>
</div>
